/*import React from 'react';
import './App.css';
import AppLayout from './Components/AppLayout'
// import firabase from '../src/Components/config'
function App() {
  return (
    <div className="App">
      <AppLayout />
    </div>
  );
}

export default App; */
import React, { useState, useEffect } from 'react';
import './App.css';
import AppLayout from './Components/AppLayout'
import firebase from './Firebase/firebase';
import Login from './Components/Login';
import Axios from 'axios';
import { ToastContainer } from 'react-toastify';

const App = () => {
  const [content, setContent] = useState();

  useEffect(() => {
    // Log user IP Address
    Axios.get('https://api.ipify.org?format=json')
      .then(res => sessionStorage.setItem("ClientIP", res.data.ip))
    localStorage.removeItem("review_id")
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase
          .getAccessToken()
          .then(d => {
            localStorage.setItem('accessToken', d);
            setContent(<AppLayout />);
          })
          .catch(e => console.log(e));
      } else {
        setContent(<Login />);
      }
    });
  }, []);

  return (
    <>
      <ToastContainer />
      {content}
    </>
  );
};

export default App;
